import React from 'react'
import LoadingSpinner from './LoadingSpinner'

interface MultiStateOption {
    value: string
    displayValue: string
    backgroundColor: string
    fontColor: string
    display: string
    icon?: JSX.Element | null
}

interface MultiStateSelectorProps {
    options: MultiStateOption[][]
    selectedValue: string
    onChange: (newValue: string) => void
    isLoading?: boolean
    className?: string
    style?: React.CSSProperties
}

const MultiStateSelector: React.FC<MultiStateSelectorProps> = ({
    options,
    selectedValue,
    onChange,
    isLoading = false,
    className,
    style,
}) => {
    const handleClick = (value: string) => {
        if (!isLoading && value !== selectedValue) {
            onChange(value)
        }
    }

    return (
        <div className={`flex flex-col gap-2 ${className || ''}`} style={style}>
            {options.map((row, rowIndex) => (
                <div className="flex gap-2" key={rowIndex}>
                    {row.map((option) => {
                        const isSelected = option.value === selectedValue

                        const inlineStyle: React.CSSProperties = {
                            backgroundColor: isSelected
                                ? option.backgroundColor
                                : '#ddd',
                            color: isSelected ? option.fontColor : '#888',
                            borderColor: isSelected
                                ? option.backgroundColor
                                : '#ccc',
                            display: option.display,
                            pointerEvents: isLoading ? 'none' : 'auto',
                            opacity: isLoading ? 0.5 : 1,
                        }

                        return (
                            <div
                                key={option.value}
                                className={`py-[0.5rem] px-[1rem] border-none rounded flex items-center gap-2 font-bold border-2 ${
                                    isSelected
                                        ? 'border-black'
                                        : 'border-black bg-[#ddd] text-white hidden'
                                }`}
                                role="button"
                                tabIndex={0}
                                onClick={() => handleClick(option.value)}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ')
                                        handleClick(option.value)
                                }}
                                style={inlineStyle}
                            >
                                {isLoading ? (
                                    <LoadingSpinner className="h-[20px]" />
                                ) : (
                                    option.icon
                                )}
                                {option.displayValue}
                            </div>
                        )
                    })}
                </div>
            ))}
        </div>
    )
}

export default MultiStateSelector
